import { call, put } from "redux-saga/effects";
import { delay } from "redux-saga";
import { push, replace } from "react-router-redux";
import { REHYDRATE } from "redux-persist/constants";
import api, { api as apiInstance } from "services/api";
import AlertsModule from "./AlertsModule";
import config from "config";

//import { constants } from "../lib/redux-acron";
//import { createModule } from "./helper/module";
//import { createModule, constants } from "redux-acron";

import { createModule, constants } from "./redux-acron";

export default createModule({
  name: "auth",
  modelName: "auth",

  state: {
    token: null,
    refreshToken: null,
    loading: false,
    error: null,
    errors: null
  },

  /**
   * Action handlers/reducer
   */
  handlers: {
    signin: (state, { payload, status = constants.PENDING_STATUS }) => {
      if (status === constants.PENDING_STATUS) {
        return state.merge({
          loading: true,
          error: false
        });
      }

      if (status === constants.SUCCESS_STATUS) {
        return state.merge({
          loading: false,
          token: payload.token,
          refreshToken: payload.refreshToken
        });
      }

      if (status === constants.FAILURE_STATUS) {
        return state.merge({
          loading: false,
          error: payload.error
        });
      }

      return state;
    },

    updateToken: (state, { payload }) => {
      apiInstance.setHeaders({
        Authorization: `Bearer ${payload.token}`
      });

      return state.merge({
        token: payload.token,
        refreshToken: payload.refreshToken
      });
    },

    signout: state => {
      apiInstance.setHeaders({
        Authorization: ""
      });

      return state.merge({
        token: null,
        refreshToken: null
      });
    },

    [REHYDRATE]: (state, { payload }) => {
      if (payload.auth && payload.auth.token) {
        apiInstance.setHeaders({
          Authorization: `Bearer ${payload.auth.token}`
        });
      }
      return state.merge({
        ...payload.auth,
        loading: false,
        errors: false,
        error: false
      });
    }
  },

  /**
   * Actions Effects
   */
  effects: {
    signin: {
      type: "latest",
      *callback(actions, { payload }) {
        const response = yield call(
          api.auth.signin,
          payload.username,
          payload.password
        );
        if (response.ok) {
          const token = response.data.id_token;
          const refreshToken = response.data.refresh_token;

          apiInstance.setHeaders({
            Authorization: `Bearer ${token}`
          });
          const userResponse = yield call(api.account.get);

          if (userResponse.ok) {
            const user = userResponse.data;
            let roles = [];
            user.authorities.forEach(auth => {
              if (config.validRoles[auth]) {
                roles = roles.concat(auth);
              }
            });
            // Se comenta este codigo por innecesario.
            /*if (!roles.length) {
              yield put(
                actions.signin(
                  {
                    error: "No tienes permisos para entrar al sistema."
                  },
                  constants.FAILURE_STATUS
                )
              );
              return;
            }*/

            yield put(AlertsModule.actionCreators.getFormData());

            yield call(delay, 500);
            yield put(
              actions.signin(
                { token, user, refreshToken },
                constants.SUCCESS_STATUS
              )
            );
          } else {
            if (userResponse.status === 404) {
              yield put(
                actions.signin(
                  { token, user: {}, refreshToken },
                  constants.SUCCESS_STATUS
                )
              );
            } else {
              //if (userResponse.)
              yield put(
                actions.signin(
                  {
                    error: "Las credenciales no son validas."
                  },
                  constants.FAILURE_STATUS
                )
              );
            }
          }
        } else {
          yield put(
            actions.signin(
              {
                error: "Las credenciales no son validas."
              },
              constants.FAILURE_STATUS
            )
          );
        }
      }
    },

    signout: {
      type: "latest",
      *callback() {
        yield put(replace('/auth'));
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/modules/AuthModule.js